import React, { useRef } from 'react'
import { Modal } from 'react-bootstrap';
import { getError, getLanguageObj, getResponse, settings } from '../../helpers/UtilsHelper';
import EmojiPicker, { EmojiStyle, Theme } from 'emoji-picker-react';
import Swal from 'sweetalert2';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';

const { icons, images, labels, messages } = settings;

const currentMethod = 'BotEmojis - function';

export default function BotEmojis({
    processValues = {
        showModal: false,
        setShowModal: () => { },
    },
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    let swalProperties = SwalPropertiesClass?.getClass();
    const inputBotEmojiId = 'inputBotEmojiId';
    const inpBotEmojiRef = useRef(null);
    const {
        showModal = false,
        setShowModal = () => { },
    } = processValues;
    //#endregion variables

    //#region methods
    const setDefault = ({
        isModalClose = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefault';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            if (isModalClose) {
                setShowModal(false);
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const copyBotEmoji = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'copyBotEmoji';
        let response = getResponse({ type: 0 });
        try {
            //#region set properties
            swalProperties = {
                toast: true,
                position: settings?.react?.sweetAlert2?.position?.topEnd,
                showConfirmButton: false,
                timer: settings?.timers?.twoSeconds,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                },
                didClose: async () => {
                    setDefault({ isModalClose: true, subMethod: currentMethod });
                },
            };
            //#endregion set properties

            //#region set value
            if (navigator?.clipboard) {
                await navigator.clipboard.writeText(e?.emoji);
            } else if (inpBotEmojiRef.current) {
                inpBotEmojiRef.current.value = e?.emoji;
                inpBotEmojiRef.current.select();
                document.execCommand('copy');
            }
            //#endregion set value

            //#region show alert
            const Toast = Swal.mixin(swalProperties);
            Toast.fire({
                icon: settings?.react?.sweetAlert2?.icons?.success,
                title: `${messages?.emojiCopiedToMemory?.[languageObj?.id]} ${e?.emoji}`,
            });
            //#endregion show alert
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
    //#endregion methods

    return (
        <Modal backdrop='static' centered contentClassName='border-0 shadow-lg login-card'
            onHide={() => setDefault({ isModalClose: true, subMethod: 'onHide - modal' })}
            show={showModal}>

            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='emojisLogo' src={images?.emojies_eyes} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.emojis?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className='badge badge-pill py-1 px-2 text-uppercase badge-info'
                            style={settings?.html?.badges?.micro}>
                            {labels?.copy?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body className='px-4 pt-2 pb-2'>
                <div className='d-flex flex-column align-items-center'>
                    <div className='form-group mb-2'>
                        <EmojiPicker
                            emojiStyle={EmojiStyle.APPLE}
                            onEmojiClick={(e) => copyBotEmoji({ e: e, subMethod: 'emojiClick' })}
                            previewConfig={{ showPreview: false }}
                            theme={Theme.LIGHT} />
                    </div>
                    <input className='form-control bg-transparent text-transparent no-border'
                        ref={inpBotEmojiRef}
                        hidden={false}
                        id={inputBotEmojiId}
                        readOnly={true}
                        style={{ border: 0, borderColor: 'transparent', height: 0, padding: 0, margin: 0 }}
                        width='10px' />
                </div>
            </Modal.Body>

            <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                <div className='d-flex justify-content-center w-100'>
                    <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                        onClick={() => setDefault({ isModalClose: true, subMethod: 'btnCloser' })}
                        data-title={labels?.back?.[languageObj?.id]}
                        type='button'>
                        <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} />
                        {labels?.back?.[languageObj?.id]}
                    </button>
                </div>
            </Modal.Footer>

        </Modal>
    )
}